import { createSlice } from "@reduxjs/toolkit";

const initialStateObj = {
  nftDetails: {},
  trendingCollectionDetail: {},
};

export const nftDetailSlice = createSlice({
  name: "nftDetail",
  initialState: initialStateObj,
  reducers: {
    setNFTDetailData: (state, { payload }) => {
      state.nftDetails = payload;
    },
    setTrendingCollectionDetail: (state, { payload }) => {
      state.trendingCollectionDetail = payload;
    },
    removeNFTDetailData: (state, { payload }) => {
      state.nftDetails = undefined;
    },
  },
});

export const {
  setNFTDetailData,
  setTrendingCollectionDetail,
  removeNFTDetailData,
} = nftDetailSlice.actions;

//it behave like connector (old redux)
export const nftDetailSelector = (state) => state.nftDetail;

export default nftDetailSlice.reducer;
